/**
 * Careers page
 *
 * Copyright (c) 2020 Coursera
 * Author: Kelvin Nguyen
 */
import React from 'react'
import Layout from 'components/Layout'
import { graphql, useStaticQuery } from 'gatsby'

const Careers = (props) => {
  const data = useStaticQuery(graphql`
    query {
      contentfulPage(slug: { eq: "careers" }) {
        ...PageFragment
      }
    }
  `)

  const careersPage = data?.contentfulPage || {}

  return (
    <Layout {...props} {...careersPage} />
  )
}

export default Careers
